<template>
  <div>
    <b-badge v-if="insufficientStatuses.includes(assignment.status)" variant="warning"> Pending</b-badge>
    <div
      v-else-if="isStaff || !assignment.company?.hidePrice"
      :class="{
        'd-flex': true,
        'align-items-center': true,
        'saved-cost': true,
        negative: percentSaved < 0,
        neutral: !percentSaved,
      }"
    >
      <span class="saved-cost__value">{{ formattedPrice(assignment.actualPrice) }}</span>
      <span
        v-if="percentSaved"
        v-b-tooltip="{ title: 'In comparison to Postnord default pricing.', class: 'saved-tooltip' }"
        class="saved-cost__percent"
      >
        {{ percentSaved }}%
      </span>
    </div>
    <div v-else>-</div>
  </div>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { BBadge } from 'bootstrap-vue-next'
import { computed, type ComputedRef, defineComponent } from 'vue'
import { OPEN, OPTIMISING, PENDING, VALIDATING, VALIDATION_COMPLETE } from '@/const/AssignmentStatuses'
import { formattedPrice } from '@/services/Helpers'
import { useAccountStore } from '@/store/account'

export default defineComponent({
  name: 'CostCell',
  components: { BBadge },
  props: {
    assignment: {
      type: Object as () => Assignment,
      required: true,
    },
  },
  setup(props) {
    const percentSaved: ComputedRef<number> = computed(() => {
      const { initialPrice, actualPrice } = props.assignment
      return !initialPrice || !actualPrice ? 0 : Math.round(((initialPrice - actualPrice) / initialPrice) * 100)
    })

    return {
      isStaff: useAccountStore().isStaff,
      insufficientStatuses: [OPEN, PENDING, VALIDATING, VALIDATION_COMPLETE, OPTIMISING],
      percentSaved,
      formattedPrice,
    }
  },
})
</script>
